<div class="container-fluid">
    <div style="background-color:#D7D7D7; border-bottom:1px grey solid; padding:25px;" *ngIf="customHTMLHeaderOnCareersSafeHtml === null">
        <img style="max-height:260px;max-width: 500px" id="logoHeader" [src]="logoUrl" alt="" />
    </div>
    <div [innerHTML]="customHTMLHeaderOnCareersSafeHtml" *ngIf="customHTMLHeaderOnCareersSafeHtml"></div>
    <div class="row dontprint mt-3">
        <div class="col-lg-2 col-md-2 col-sm-2"></div>
        <div>
            <div class="row col-lg-5 col-md-5 col-sm-5">
                <button class="btn btn-primary" (click)="backToJobListings()">
                    <span><i class="modus-icons align-bottom">chevron_left</i></span> Back to Job Postings
                </button>
            </div>
        </div>
    </div>
    <div class="row" *ngIf="jobDetails">
        <div class="col-lg-2 col-md-2 col-sm-2"></div>
        <div class="col-lg-8 col-md-10 col-sm-8">
            <div class="row">
                <h3 style="margin-top:25px">{{jobDetails.PositionTitle}} <br class="d-sm-none" /><span *ngIf="showRequisitionNumberOnExternalATSPosting">(Req #: {{jobDetails.ReqNum}})</span> </h3>
                <div class="dontprint d-none d-sm-block" style="margin-left:25px;" *ngIf="showPIN">
                    <a href="#" (click)="applyWithPin()" style="float:right;margin-top:25px;" class="d-none d-sm-block">Have a PIN ?</a>
                    <a href="#" (click)="applyWithPin()" style="margin-top:25px;" class="d-block d-sm-none">Have a PIN ?</a>
                </div>
            </div>
            <div class="row d-block d-sm-none">
                <div class="dontprint" style="margin-left:25px;" *ngIf="showPIN">
                    <a href="#" (click)="applyWithPin()" style="float:right;margin-top:25px;" class="d-none d-sm-block">Have a PIN ?</a>
                    <a href="#" (click)="applyWithPin()" style="margin-top:25px;" class="d-block d-sm-none">Have a PIN ?</a>
                </div>
            </div>
        </div>
    </div>
    <hr />
    <div class="row dontprint mb-2">
        <div class="col-lg-2 col-md-2 col-sm-2"></div>
        <div class="row col-lg-4 col-md-4 col-sm-10" style="margin-bottom:10px;" *ngIf="jobDetails.IsApplyOnline && !reqDetailWait && jobDetails.ReqStatus != 0">
            <button (click)="applyJob()" class="btn btn-success btn-xl" type="button" *ngIf="jobDetails.IsApplyOnline && !reqDetailWait" style="margin-bottom:5px;">Apply Now</button>
        </div>
        <div class="col-2 d-block d-md-none"></div>
        <div class="row col-lg-6 col-md-6 col-sm-10" style="margin-bottom:10px;">
            <a class="btn btn-outline-dark" href="mailto:?subject={{subject}}&body={{body}}" style="margin-bottom:5px;">Share via Email</a>
            <button class="btn btn-outline-dark" type="button" (click)="print()" style="margin-bottom:5px;">Print</button>
            <a class="btn" style="padding:0px;margin-left:5px;margin-bottom:5px;" href="http://www.facebook.com/sharer.php?u={{link}}&text=test" target="_blank"><img src="/Cache/images/FB_Logo.png" style="max-width:30px;" /></a>
            <a class="btn" style="padding:0px;margin-left:5px;margin-bottom:5px;" href="http://twitter.com/share?url={{link}}" target="_blank"><img src="/Cache/images/Twitter_Logo.png" style="max-width:30px;" /></a>
            <a class="btn" style="padding:0px;margin-left:5px;margin-bottom:5px;" href="https://www.linkedin.com/shareArticle?mini=true&url={{link}}" target="_blank"><img src="/Cache/images/LI_Logo.png" style="max-width:35px;" /></a>
        </div>
    </div>
    <div class="row" *ngIf="jobDetails != null">
        <div class="col-lg-2 col-md-2 col-sm-2"></div>
        <div class="row col-md-8 col-sm-8 col-xs-8 d-inline-block">
            <div class="row">
                <div class="col-lg-6 col-md-6 col-sm-10 job-info">
                    <label style="margin-left:8px;"><strong>Position Title:</strong></label>
                    <div style="font-size:large;margin-left:8px;">{{jobDetails.PositionTitle}}</div>
                </div>
                <div class="col-lg-3 col-md-3 col-sm-10 job-info">
                    <label style="margin-left:8px;"><strong>Date Posted:</strong></label>
                    <div style="font-size:large;margin-left:8px;">{{jobDetails.DatePostedDisplay}}</div>
                </div>
            </div>
            <div class="row mt-3">
                <div class="col-lg-3 col-md-3 col-sm-10 job-info">
                    <label style="margin-left:8px;"><strong>Location:</strong></label>
                    <div style="font-size:large;margin-left:8px;">{{jobDetails.City}}, {{jobDetails.State}}</div>
                </div>
                <div class="col-lg-3 col-md-3 col-sm-10 job-info" *ngIf="!hideCategoryFromCareersPage">
                    <label style="margin-left:8px;"><strong>Job Category:</strong></label>
                    <div style="font-size:large;margin-left:8px;">{{jobDetails.OnboardProfileName}}</div>
                </div>
                <div class="col-lg-3 col-md-3 col-sm-10 job-info" *ngIf="showSalaryInterval">
                    <label style="margin-left:8px;"><strong>Salary Interval:</strong></label>
                    <div style="font-size:large;margin-left:8px;">{{jobDetails.SalaryIntervalDisplay}}</div>
                </div>
                <div class="col-lg-3 col-md-3 col-sm-10 job-info">
                    <label style="margin-left:8px;"><strong>Pay Range:</strong></label>
                    <div *ngIf="jobDetails.PayRangeLow != null || jobDetails.PayRangeHigh != null" style="margin-left:8px;">
                        <span style="font-size: large;">{{jobDetails.PayRangeLow | currency:currencySymbol}}</span>
                        <span style="font-size: large;"> - </span>
                        <span style="font-size: large;">{{jobDetails.PayRangeHigh | currency:currencySymbol}}</span>
                    </div>
                    <div style="font-size:large;margin-left:8px;" *ngIf="jobDetails.PayRangeLow == null && jobDetails.PayRangeHigh == null">N/A</div>
                </div>
            </div>
            <div class="row mt-3" *ngIf="jobDetails.PositionInstructions != null && jobDetails.PositionInstructions !== ''">
                <div class="col-12">
                    <div class="card border">
                        <div class="card-header bg-light"><b>Application Instructions</b></div>
                        <div class="card-body">
                            <div class="col-md-12">
                                <div style="margin-left:8px;"><quill-view [content]="jobDetails.PositionInstructions"></quill-view></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row mt-3" *ngIf="jobDetails.PositionDesc != null && jobDetails.PositionDesc !== ''">
                <div class="col-12">
                    <div class="card border">
                        <div class="card-header bg-light"><b>Position Description</b></div>
                        <div class="card-body">
                            <div class="col-md-12">
                                <div style="margin-left:8px;"><quill-view [content]="jobDetails.PositionDesc"></quill-view></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row mt-3" *ngIf="jobDetails.PositionRequirements != null && jobDetails.PositionRequirements !== ''">
                <div class="col-12">
                    <div class="card border">
                        <div class="card-header bg-light"><b>Position Requirements</b></div>
                        <div class="card-body">
                            <div class="col-md-12">
                                <div style="margin-left:8px;"><quill-view [content]="jobDetails.PositionRequirements"></quill-view></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row mt-3" *ngIf="jobDetails.PositionNotes != null && jobDetails.PositionNotes !== ''">
                <div class="col-12">
                    <div class="card border">
                        <div class="card-header bg-light"><b>Equal Opportunity Employer</b></div>
                        <div class="card-body">
                            <div class="col-md-12">
                                <div style="margin-left:8px;"><quill-view [content]="jobDetails.PositionNotes"></quill-view></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-lg-2 col-md-2 col-sm-2"></div>
        <div class="row col-lg-8 col-md-8 col-sm-8" style="display:inline-block;">
            <div class="alert alert-warning mt-3" *ngIf="careerJobFooterMsg != null"><quill-view [content]="careerJobFooterMsg"></quill-view></div>
        </div>
    </div>
</div>
